import * as vp from 'vopay';
import { FunctionComponent } from 'react';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { UtilButton } from 'UI';

const { Box, Title, SubTitle, Button } = vp;
type FC = FunctionComponent;
const Flinks: FC = () => {
  const history = useHistory();
  const { t } = useTranslation('translations', { keyPrefix: 'Integrations.Flinks' });
  const { t: tInt } = useTranslation('translations', { keyPrefix: 'Integrations' });
  const { t: tGlobal } = useTranslation('translations', { keyPrefix: 'Global' });

  return (
    <div>
      <Box flx="col" mb="md" gapSize="16px">
        <UtilButton
          iconLeft="chevron_left"
          size="large"
          onClick={() => {
            if (history.length > 1) {
              history.goBack();
            } else {
              history.replace('/integrations');
            }
          }}
        >
          {history.length > 1 ? tGlobal('Buttons.back') : tInt('pageTitle')}
        </UtilButton>
        <Title title={t('pageTitle')} />
      </Box>
      <Box flx="col">
        <Box mb="sm">{t('description')}</Box>
        <Box mb="sm">{t('link')}</Box>
        <Box mb="sm">{t('descriptionTwo')}</Box>
        <SubTitle subTitle={t('howItWorks')} />
        <Box mb="sm">{t('howItWorksDescription')}</Box>
        <Box mb="sm" ps="lg">
          <ol>
            <li>{t('navigateToFlinksLogin')}</li>
            <li>{t('selectFinancialInstitution')}</li>
            <li>{t('userLoginBankAccount')}</li>
            <li>{t('selectBankAccount')}</li>
            <li>{t('redirectWithLoginAndAccountId')}</li>
            <li>{t('apiCallWithFlinksIds')}</li>
            <li>{t('fetchAccountDetailsForEft')}</li>
          </ol>
        </Box>

        <Box mt="lg" jc="fe">
          <Box>
            <Button
              id="Flinks-update"
              label={t('updateUrlButton')}
              onClick={() => {
                history.push('/integrations/Flinks/update');
              }}
            />
          </Box>
        </Box>
      </Box>
    </div>
  );
};
export default Flinks;
